import React from 'react';
import PropTypes from 'prop-types';
import '../assets/styles.css'
import errorCircle from '../assets/error_circle.png'

const Checkbox = ({ text, name, onChange, validationMessage, disabled }) => {
    return (
        <div className='_kanis_checkbox_group'>
            <div style={{display: 'flex'}}>
                <div className='kanis_checkbox_wrapper'>
                    <input
                        disabled={disabled}
                        name={name}
                        id="_kanis_checkbox" 
                        className={`_kanis_checkbox`}
                        type="checkbox"
                        onClick={(e) => onChange({ checked : e.target.checked })}
                    />
                </div>
                <label htmlFor="_kanis_checkbox">{text}</label>
            </div>
            {
                !!validationMessage && (
                    <div className='_kanis_validation_message' style={{marginLeft: '32px'}}>
                        <img src={errorCircle} alt='error' />
                        <div>{validationMessage}</div>
                    </div>
            )}
        </div>
    );
}

export default Checkbox;

Checkbox.propTypes = {
    text: PropTypes.string,
    name: PropTypes.string,
    validationMessage: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool
};